import React from 'react'

const Energy = () => {
  return (
    <div>Energy</div>
  )
}

export default Energy